<template>
  <div>
    <v-data-table
      mobile-breakpoint="0"
      item-key="id"
      :options.sync="tableOptions"
      :server-items-length="totalItems"
      :headers="headers"
      :items="documents"
      :footer-props="footerTable"
      v-bind="this.$attrs"
      loading-text="Đang Tải"
      :loading="loading"
      no-data-text="Không có file"
      :show-select="role.type !== 'inspector'"
      v-model="selecteds"
      @input="$emit('update:selected', selecteds)"
    >
      <template v-slot:[`footer.page-text`]="items">
        {{ items.pageStart }} - {{ items.pageStop }} trên
        {{ items.itemsLength }}
      </template>
      <template v-slot:[`item.title`]="{ item }">
        <div @click="item.file ? openLink(item.file) : null" style="color: #1a0dab;; cursor: pointer">
          {{ item.file && item.file.name }}
        </div>
      </template>
      <template v-slot:[`item.createdAt`]="{ item }">
        {{ item.createdAt | ddmmyyyy }}
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn class="elevation-0" icon @click="remove(item)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <OfficeViewer :state="previewDialog" :file="selectedFile" />
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import OfficeViewer from '@/components/basic/office-viewer/OfficeViewer.vue'

export default {
  data() {
    return {
      headers: [],
      tableOptions: {},
      selecteds: [],
      previewDialog: false,
      selectedFile: null
    }
  },
  props: {
    selected: {
      type: Array,
      default: () => []
    }
  },
  components: {
    OfficeViewer
  },
  computed: {
    ...mapState('Documents', ['totalItems', 'documents', 'pageText', 'loading']),
    ...mapGetters('auth', ['ownClassIds', 'profile', 'role']),

    footerTable() {
      let footer = {
        'items-per-page-text': 'Số tài liệu mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 10,
        'page-text': this.pageText
      }
      if (this.totalItems > 100) {
        footer['items-per-page-options'] = [5, 10, 15]
      }
      return footer
    }
  },
  methods: {
    ...mapActions('Documents', ['requestPageSettings', 'searchDocuments', 'removeDocument']),
    ...mapActions('upload', ['destroy']),
    async refresh(query) {
      await this.searchDocuments(query)
    },
    openLink(file) {
      this.previewDialog = !this.previewDialog
      this.selectedFile = file
    },
    async remove(document) {
      this.$dialog.confirm({
        title: 'Xóa tài liệu',
        text: `Bạn có chắc muốn xóa tài liệu này không?`,
        okText: 'Có',
        type: 'delete',
        cancelText: 'Hủy',
        done: async () => {
          this.$loading.active = true
          try {
            await this.removeDocument(document.id)
            this.destroy(document.file.id)
            this.$alert.deleteSuccess()
          } catch (error) {
            this.$alert.deleteError()
          } finally {
            this.$loading.active = false
          }
        }
      })
    }
  },
  async created() {
    const typeId = this.$route.params.id
    const params = {
      documentType: typeId,
      _sort: 'createdAt:DESC'
    }
    if (this.role.type === 'inspector') {
      this.headers = [
        {
          text: 'Tên tài liệu',
          value: 'title',
          align: 'left',
          sortable: false,
          show: true
        },
        {
          text: 'Người tạo',
          value: 'createdTeacher.name',
          align: 'left',
          sortable: false,
          show: true
        }
      ]
    } else if (this.role.type === 'teacher') {
      params.createdTeacher = this.profile.id
      this.headers = [
        {
          text: 'Tên tài liệu',
          value: 'title',
          align: 'left',
          sortable: false,
          show: true
        },
        {
          text: 'Ngày tạo',
          value: 'createdAt',
          align: 'left',
          sortable: false,
          show: true
        },
        {
          text: 'Thao tác',
          value: 'actions',
          align: 'left',
          sortable: false,
          show: true
        }
      ]
    } else {
      this.headers = [
        {
          text: 'Tên tài liệu',
          value: 'title',
          align: 'left',
          sortable: false,
          show: true
        },
        {
          text: 'Người tạo',
          value: 'createdTeacher.name',
          align: 'left',
          sortable: false,
          show: true,
          width: 300
        },
        {
          text: 'Ngày tạo',
          value: 'createdAt',
          align: 'left',
          sortable: false,
          show: true
        },
        {
          text: 'Thao tác',
          value: 'actions',
          align: 'left',
          sortable: false,
          show: true
        }
      ]
    }
    await this.refresh(params)
  },
  filters: {},
  watch: {
    tableOptions: {
      handler(newOptions, oldOptions) {
        const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
        const pageChanged = newOptions.page !== oldOptions.page
        if (pageChanged || itemPerPageChanged) {
          this.requestPageSettings({
            page: newOptions.page,
            itemsPerPage: newOptions.itemsPerPage
          })
        }
      },
      deep: true
    },
    selected(value) {
      if (value) this.selecteds = value
    }
  }
}
</script>

<style scoped>
.cal-high {
  background-color: hotpink;
}
.cal-medium {
  background-color: lightpink;
}
.cal-low {
  background-color: lightgoldenrodyellow;
}
</style>
